import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'
import { Button, Typography, Box, CircularProgress, Switch, FormGroup, FormControlLabel } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import UsernameDomainEditor from './UsernameDomainEditor'

class SlateSetupPresentation extends React.Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    isSyncing: PropTypes.bool.isRequired,
    testResult: PropTypes.bool,
    domain: PropTypes.string,
    needsSaved: PropTypes.bool.isRequired,
    onTestConnection: PropTypes.func.isRequired,
    onActivateToggle: PropTypes.func.isRequired,
    onDomainSave: PropTypes.func.isRequired,
    onDomainModification: PropTypes.func.isRequired,
  }
  render() {
    const canActivate = !this.props.needsSaved && (this.props.testResult || this.props.isActive)
    return (
      <Box mt={2}>
        <UsernameDomainEditor
          canEdit={!this.props.isActive}
          domain={this.props.domain}
          onSave={this.props.onDomainSave}
          onModification={this.props.onDomainModification}
        />
        <Box mt={1}>
          <Typography gutterBottom>Confirm that we are able to connect.</Typography>
        </Box>
        <Box my={2}>
          <Button
            color="primary"
            size="large"
            variant="contained"
            disabled={
              this.props.isSyncing || this.props.isActive || isEmpty(this.props.domain) || this.props.needsSaved
            }
            onClick={this.props.onTestConnection}
          >
            Test Connection
          </Button>
        </Box>
        {this.props.isSyncing && (
          <Box m={2}>
            <CircularProgress
              aria-label="loading"
              role="status"
              size="25px"
            />
          </Box>
        )}
        {this.props.testResult === true && (
          <Box my={2}>
            <Alert severity="success">Test Connection was successful</Alert>
          </Box>
        )}
        {this.props.testResult === false && (
          <Box my={2}>
            <Alert severity="error">Test Connection failed. Please try again or contact support.</Alert>
          </Box>
        )}
        {canActivate && (
          <Box
            mt={2}
            mx={1}
          >
            <FormGroup>
              <FormControlLabel
                label="Turn on Slate Integration"
                control={
                  <Switch
                    checked={this.props.isActive}
                    onChange={(e) => this.props.onActivateToggle(e.target.checked)}
                    color="primary"
                  />
                }
              />
            </FormGroup>
          </Box>
        )}
      </Box>
    )
  }
}

export default SlateSetupPresentation
